import React from "react";
import "./styles.css";

function CoreBox(props) {
  return (
    <div className={`coreCol ${props.customClass} ${props.color}`}>
      <span>{props.count}</span>
      <div className="coreColIcon">
        <i><img src={props.src} alt={props.title} /></i>
      </div>
      <div className="coreColInfo">
        <h4>{props.title}</h4>
        <p>{props.description}</p>
      </div>
    </div>   
  );
}
export default CoreBox;